<script lang="ts">
    import {_, date, time} from 'svelte-i18n'
    import Layout from './Layout.svelte';
    import LoadingDiv from './LoadingDiv.svelte';
    import DataTable, {Body, Cell, Head, Row} from '@smui/data-table';
    import {richSessionRemoteRepository} from './services';

    const sessionsPromise = richSessionRemoteRepository.fetchSessions();
</script>

<Layout>
    <div style="margin: 36px 50px 20px 50px;">
        <div class="mdc-typography--headline4">{$_('user.session.SessionLog')}</div>

        <div style="margin-top: 10px;">
            {#await sessionsPromise}
                <LoadingDiv design="calm" />
            {:then sessions}

                <DataTable table$aria-label="Login log">
                    <Head>
                        <Row>
                            <Cell>{$_('user.User')}</Cell>
                            <Cell>{$_('user.session.Login')}</Cell>
                            <Cell>{$_('user.session.Logout')}</Cell>
                            <Cell>{$_('commons.IpAddress')}</Cell>
                        </Row>
                    </Head>
                    <Body>
                    {#each sessions as session (session.id)}
                        <Row>
                            <Cell>{session.userUsername}</Cell>
                            <Cell>{$date(session.createDate, {format: 'long'})} {$time(session.createDate, {format: 'short'})}</Cell>
                            <Cell>
                                {#if session.endDate}
                                    {$date(session.endDate, {format: 'long'})} {$time(session.endDate, {format: 'short'})}
                                {/if}
                            </Cell>
                            <Cell>{session.ipAddress}</Cell>
                        </Row>
                    {/each}
                    </Body>
                </DataTable>

            {:catch error}
                <p style="color: red">{error}</p>
            {/await}
        </div>
    </div>
</Layout>